import script from "./BlueAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueAlert.vue?vue&type=script&setup=true&lang=js"

import "./BlueAlert.vue?vue&type=style&index=0&id=3615e846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3615e846"]])

export default __exports__